var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRouteIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2509_82759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.40728 13.4565V8.03983C3.40728 7.04526 3.79798 6.09144 4.49343 5.38817C5.18887 4.68491 6.1321 4.28983 7.11562 4.28983C8.09913 4.28983 9.04236 4.68491 9.7378 5.38817C10.4333 6.09144 10.8239 7.04526 10.8239 8.03983V13.8732C10.8239 14.4257 11.041 14.9556 11.4274 15.3463C11.8137 15.737 12.3377 15.9565 12.8841 15.9565C13.4305 15.9565 13.9545 15.737 14.3409 15.3463C14.7273 14.9556 14.9443 14.4257 14.9443 13.8732V8.31483C14.3943 8.11824 13.9306 7.73133 13.6354 7.22249C13.3402 6.71365 13.2323 6.11564 13.3309 5.53417C13.4296 4.9527 13.7283 4.42521 14.1743 4.04493C14.6204 3.66466 15.185 3.45609 15.7684 3.45609C16.3518 3.45609 16.9164 3.66466 17.3625 4.04493C17.8085 4.42521 18.1072 4.9527 18.2059 5.53417C18.3045 6.11564 18.1966 6.71365 17.9014 7.22249C17.6062 7.73133 17.1425 8.11824 16.5925 8.31483V13.8732C16.5925 14.8677 16.2018 15.8215 15.5063 16.5248C14.8109 17.2281 13.8676 17.6232 12.8841 17.6232C11.9006 17.6232 10.9574 17.2281 10.2619 16.5248C9.5665 15.8215 9.1758 14.8677 9.1758 13.8732V8.03983C9.1758 7.48729 8.95875 6.95739 8.57239 6.56669C8.18603 6.17599 7.66201 5.95649 7.11562 5.95649C6.56922 5.95649 6.0452 6.17599 5.65884 6.56669C5.27248 6.95739 5.05543 7.48729 5.05543 8.03983V13.4565H7.52765L4.23136 17.6232L0.935059 13.4565H3.40728Z",
    fill: "#737373"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2509_82759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.7778,
    height: 20,
    fill: "white",
    transform: "translate(0.11084 0.956482)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteIcon);
export default __webpack_public_path__ + "static/media/routeIcon.569f8d34335b6b718a54b1a6c1f479e1.svg";
export { ForwardRef as ReactComponent };